export const actionTrackTypes = Object.freeze({
  0: "Start Consultation",
  1: "Stop Consultation",
  2: "Manual Transcription",
});
